import {Component, HostBinding} from '@angular/core';
import {TranslationSelectorService} from '../../shared/translation-selector.service';

@Component({
  selector: 'app-language-menu',
  templateUrl: './language-menu.component.html',
})
export class LanguageMenuComponent {
  selectedLanguage: string;

  supportedLanguages: string[] = [];

  constructor(
    private translationSelector: TranslationSelectorService,
  ) {
    this.supportedLanguages = this.translationSelector.getAvailableLanguages();
    this.selectedLanguage = this.translationSelector.getSelectedLanguage();
  }

  setLanguage(language) {
    this.translationSelector.setLanguage(language);
  }
}
